<template>
  <div id="app">
    <a-layout>
      <a-row class="header-row" :gutter="[16, 16]">
        <a-col :span="1"></a-col>
        <a-col :span="6" :style="{ padding: '6px 0 0 0', fontSize: '30px', fontWeight: '550', color: '#ffffff', height: '70px', display: 'flex', alignItems: 'center' }">
          <span>机动车自助选号系统</span>
        </a-col>
        <a-col :span="14"></a-col>
        <a-col :span="3" :style="{ padding: '8px 0 0 0', fontSize: '18px', color: '#ffffff', height: '70px', gap: '20px', display: 'flex', alignItems: 'center' }">
          <span>{{ currentDate }}</span>
          <span>{{ currentTime }}</span>
        </a-col>
      </a-row>
      <a-layout>
        <a-layout-content>
          <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import api from './api'

export default {
  name: 'App',
  data () {
    return {
      currentDate: '',
      currentTime: ''
    }
  },
  methods: {
    updateDateTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      this.currentDate = `${year}年${month}月${day}日`
      
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.currentTime = `${hours}:${minutes}:${seconds}`
    },
    async checkUserStatus () {
      // 如果已登录，检查用户状态
      if (this.$store.state.isLoggedIn) {
        const currentUser = this.$store.state.currentUser
        
        if (!currentUser || !currentUser.username) {
          return
        }
        
        // 管理员跳过检查
        if (currentUser.role === 'admin') {
          return
        }
        
        try {
          // 检查用户状态（是否被禁用）
          const response = await api.checkUserStatus(currentUser.username)
          
          if (response.success && response.data) {
            const userStatus = response.data
            
            // 如果用户被禁用，强制退出
            if (userStatus.is_disabled) {
              this.$message.error('您的账号已被管理员禁用，无法继续使用')
              this.$store.commit('setIsLoggedIn', false)
              this.$store.commit('setCurrentUser', null)
              if (this.$route.path !== '/login') {
                this.$router.push('/login')
              }
              return
            }
            
            // 如果用户未审批，强制退出
            if (!userStatus.is_approved) {
              this.$message.warning('您的账号尚未通过管理员审批，请等待审批后登录')
              this.$store.commit('setIsLoggedIn', false)
              this.$store.commit('setCurrentUser', null)
              if (this.$route.path !== '/login') {
                this.$router.push('/login')
              }
              return
            }
          }
        } catch (error) {
          console.error('检查用户状态失败:', error)
          // 网络错误时不强制退出，允许用户继续使用
        }
      }
    },
    async checkSession () {
      // 如果已登录，检查session是否有效
      if (this.$store.state.isLoggedIn) {
        const sessionToken = this.$store.state.sessionToken || localStorage.getItem('sessionToken')
        
        if (!sessionToken) {
          // 没有session token，清除登录状态
          this.$store.commit('setIsLoggedIn', false)
          this.$store.commit('setCurrentUser', null)
          this.$store.commit('setSessionToken', null)
          if (this.$route.path !== '/login') {
            this.$router.push('/login')
          }
          return
        }
        
        try {
          // 验证session是否有效
          const response = await api.verifySession()
          
          if (!response.success) {
            // Session无效，清除登录状态（可能是单点登录导致）
            this.$message.warning('登录已过期或在其他设备登录，请重新登录')
            this.$store.commit('setIsLoggedIn', false)
            this.$store.commit('setCurrentUser', null)
            this.$store.commit('setSessionToken', null)
            if (this.$route.path !== '/login') {
              this.$router.push('/login')
            }
          }
        } catch (error) {
          console.error('检查session失败:', error)
          // 网络错误时不强制退出，允许用户继续使用
        }
      }
    }
  },
  mounted () {
    this.updateDateTime()
    this.timer = setInterval(this.updateDateTime, 1000)
    
    // 检查用户状态和session状态
    this.checkUserStatus()
    this.checkSession()
    
    // 定期检查用户状态（每5分钟）
    this.userCheckTimer = setInterval(() => {
      this.checkUserStatus()
    }, 5 * 60 * 1000)
    
    // 定期检查session状态（每5分钟）
    this.sessionCheckTimer = setInterval(() => {
      this.checkSession()
    }, 5 * 60 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    if (this.userCheckTimer) {
      clearInterval(this.userCheckTimer)
    }
    if (this.sessionCheckTimer) {
      clearInterval(this.sessionCheckTimer)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app .ant-layout-sider {
  background: #3ba0e9;
  color: #fff;
  height: calc(100vh - 60px);
}

#app .ant-layout-content {
  background: #fff;
  height: calc(100vh - 60px);
  overflow: hidden;
}

#app .ant-layout-header {
  background: #3ba0e9;
  color: #fff;
  height: 60px;
}

#app .header-row {
  height: 80px;
  margin-bottom: 0;
  background-image: url(/img/header.578b4acd.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

